import { RuntimeConfigService } from "../services/runtime-config.service";

export function initializeApp(configService: RuntimeConfigService): () => Promise<void> {
    return () =>
        configService.loadConfig().then(() => {
        }).catch((error) => {
            console.error("Failed to initialize application configuration", error);
        });
}
